<!--/* eslint-disable */-->
<template>

  <div>
    <vx-card>

      <div class="vx-row mb-4">
        <div class="vx-col w-1/2">
          <label>CNPJ Cliente</label>
          <CnpjInput
            :disable="!isCreateOrAssigned"
            v-model="cnpjClient"
            name="cnpj"
            class="w-full"/>
          <span class="text-danger" v-if="notFoundClient != null">{{notFoundClient}}</span>
        </div>
        <div class="vx-col w-1/2">
          <label>CNPJ Garantidor</label>
          <CnpjInput
            :disable="!isCreateOrAssigned"
            v-model="cnpjGarantor"
            name="cnpj garantidor"
            class="w-full"/>
          <span class="text-danger" v-if="notFoundGarantor != null">{{notFoundGarantor}}</span>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-1/2">
          <vs-button class="bg-primary" @click="getCompany(true)" :disabled="!isCreateOrAssigned">Buscar Cliente</vs-button>
        </div>
        <div class="vx-col w-1/2">
          <vs-button class="bg-primary" @click="getCompany(false)" :disabled="!isCreateOrAssigned">Buscar Garantidor</vs-button>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-1/2">
          <label>Cliente é o garantidor</label>
          <vs-switch v-model="clientIsGuarantor"/>
        </div>
      </div>

    </vx-card>

    <vx-card class="mt-4">
      <vs-row vs-type="flex">

        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <company-form :companyForm="propose.config.client" title="Dados do cliente" ref="clientForm"></company-form>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="12" vs-xs="12" >
          <company-form :companyForm="propose.config.guarantor" title="Dados do garantidor" ref="guarantorForm"></company-form>
        </vs-col>

      </vs-row>
    </vx-card>

<!--    <vx-card class="mt-4" title="Tipo da proposta">-->
<!--      <vs-row vs-type="flex" class="mb-4">-->
<!--        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">-->
<!--          <vs-select class="ml-4" v-model="propose.proposeType">-->
<!--            <vs-select-item v-for="(item, index) in proposeTypes" :key="index" :text="item.description"-->
<!--                            :value="item.value"/>-->
<!--          </vs-select>-->
<!--        </vs-col>-->
<!--      </vs-row>-->
<!--    </vx-card>-->

    <vx-card class="mt-4" title="Prazo de fornecimento" v-if="propose.proposeType === 'ENERGY'">
      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <vs-button @click="downloadTemplate">Download Template</vs-button>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <UploadPropostaFile :updateValues="updateValues" ref="uploadProposta"/>
        </vs-col>
      </vs-row>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-table stripe :data="propose.config.values" noDataText="Nenhum registro encontrado.">

            <template slot="thead">
              <th>Início</th>
              <th>Fim</th>
              <th>Tipo da Operação</th>
              <th>Volume (Mwmedio)</th>
              <th>Preço (R$/MWh)</th>
              <th>Submercado</th>
              <th>Tipo de Energia</th>
              <th>Volume financeiro (R$)</th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <td>
                  {{row.startDate | formatDate}}
                </td>
                <td>
                  {{row.endDate | formatDate}}
                </td>
                <td>
                  {{row.operationType | formatOperationType}}
                </td>
                <td>
                  {{row.qtdMwMed | toDecimal}}
                </td>
                <td>
                  {{row.price | toDecimal}}
                </td>
                <td>
                  {{row.market | formatMarket}}
                </td>
                <td>
                  {{row.energyType | formatEnergyType}}
                </td>
                <td>
                  {{row.amount | toDecimal}}
                </td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </div>

      <vs-row v-if="propose.config.values.length > 0">
        <vs-col>
          <vs-button @click="eraseValues">Apagar valores</vs-button>
        </vs-col>
      </vs-row>

    </vx-card>

    <vx-card class="mt-4" title="Valor da proposta" v-if="propose.proposeType === 'UNDEFINED_TIME'">
      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
          <label>Valor mensal em R$</label>
          <NumericInput
            :disable="!isCreateOrAssigned"
            v-model="propose.config.totalAmount"
            name="garantia"
            isPositive='true'
            v-validate="'required'"
            minimumFractionDigits="2"
            class="w-full"
          />
          <span class="text-danger text-sm" v-show="errors.has('garantia')">{{ errors.first('garantia') }}</span>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card class="mt-4" title ="Garantia Proposta pelo Cliente" v-if="propose.proposeType === 'ENERGY'">
          <vs-row vs-type="flex" class="mb-4">
            <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
              <label>Modalidade</label>
              <vs-select
                :disabled="!isCreateOrAssigned"
                v-model="propose.config.guaranteeType"
                name="modalidade"
                v-validate="'required'"
                class="w-full">
                <vs-select-item :key="index" :value="item.value" :text="item.description" v-for="(item, index) in guaranteeTypes" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('modalidade')">{{ errors.first('modalidade') }}</span>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6" vs-xs="12" v-if="propose.config.guaranteeType !== 'CORPORATE' && propose.config.guaranteeType !== 'UNSECURED' && propose.config.guaranteeType !== 'PAYMENT_REGISTER'">
              <label>Meses de Garantia</label>
              <NumericInput
                :disable="!isCreateOrAssigned"
                v-model="propose.config.guaranteePeriod"
                name="garantia"
                v-validate="'required'"
                minimumFractionDigits="0"
                class="w-full"
              />
              <span class="text-danger text-sm" v-show="errors.has('garantia')">{{ errors.first('garantia') }}</span>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
              <label>Prazo de Pagamento em Dias</label>
              <NumericInput
                :disable="!isCreateOrAssigned"
                v-model="propose.config.paymentTerm"
                name="prazo de pagamento"
                v-validate="'required'"
                minimumFractionDigits="0"
                class="w-full"
              />
              <span class="text-danger text-sm" v-show="errors.has('prazo de pagamento')">{{ errors.first('prazo de pagamento') }}</span>
            </vs-col>
          </vs-row>

          <vs-row vs-type="flex" class="mb-4">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <label>Comentário</label>
              <vs-textarea
                :disabled="!isCreateOrAssigned"
                height="250px"
                v-model="propose.config.comments"
              />
            </vs-col>

            <vs-col v-if="propose.slaMessage" vs-lg="6" vs-sm="6" vs-xs="12">
              <vs-list>
                <vs-list-header title="Comentários"></vs-list-header>
                <vs-list-item icon="person" v-for="(row, indextr) in propose.slaMessage" :key="indextr"
                              :title="row.title" :subtitle="row.subtitle"/>
              </vs-list>
            </vs-col>
          </vs-row>
        </vx-card>

    <vs-row vs-type="flex" class="mt-4" vs-align="space-between">
      <vs-col v-show="complianceServiceType !== null" vs-lg="6" vs-sm="12" vs-xs="12" style="padding-left: 0">
        <vs-card v-if="isCreateOrAssigned" class="cardx" fixedHeight>
          <div slot="header">
            <h3>
              Compliance
            </h3>
          </div>

          <div>
            <ComplianceForm ref="complianceForm" :company-guid="propose.config.guarantor.guid"/>
          </div>
          <div slot="footer"></div>
        </vs-card>
      </vs-col>


      <vs-col vs-lg="6" vs-sm="12" vs-xs="12" style="padding-left: 0">
        <vs-card v-if="isCreateOrAssigned" class="cardx" fixedHeight>
          <div slot="header">
            <h3>
              Serasa
            </h3>
          </div>

          <div>
            <SerasaForm ref="serasaForm" :company-guid="propose.config.guarantor.guid"/>
          </div>

          <div slot="footer"></div>
        </vs-card>
      </vs-col>

    </vs-row>


    <vx-card class="mt-4" title="Upload Demonstrativos Contábeis (do Garantidor) - SERASA - COMPLIANCE" subtitle="Balanço (Assinado), DRE (Assinado) e Organograma da empresa (Se tiver)">

          <div class="vx-row">
            <div class="vx-col w-1/2">
              <vs-table stripe :data="files" class="mt-6" noDataText="Escolha um ou mais arquivos para anexar na proposta">
                <template slot="header">
                  <h3>
                    Anexar arquivos
                  </h3>
                </template>

                <template slot="thead">
                  <th>Nome</th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr v-for="(row, indextr) in data" :key="indextr">
                    <vs-td>
                      {{ row.name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div class="vx-col w-1/2">
              <vs-table v-if="propose.files.length > 0" class="mt-6" stripe :data="propose.files" noDataText="Não há arquivos cadastrados nesta proposta">

                <template slot="header">
                  <h3>
                    Arquivos anexados
                  </h3>
                </template>

                <template slot="thead">
                  <th>Arquivos</th>
                  <th>Criado Por</th>
                  <th>Data</th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr v-for="(row, indextr) in data" :key="indextr">
                    <vs-td>
                      <a style="cursor: pointer" @click="downloadFile(row.fileName)">{{ row.fileName }}</a>
                    </vs-td>
                    <vs-td>{{ row.createdBy.email }}</vs-td>
                    <vs-td>{{ row.createdAt | formatDateTime }}</vs-td>
                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </div>

          <div class="vx-row mt-4" v-if="isCreateOrAssigned">

            <div class="vx-col mt-4">
              <label class="file-select">
                <div class="select-button">
                  <span class="vs-component vs-button vs-button-primary vs-button-filled">Upload</span>
                </div>
                <input type="file" multiple id="file" ref="file" v-on:change="handleFileUpload()"/>
              </label>
            </div>

          </div>
        </vx-card>

    <vs-button class="bg-primary mt-4" @click="back">Voltar</vs-button>
    <vs-button v-if="this.propose.guid !== null" class="bg-danger-gradient ml-2 mt-4" @click="denyPropose()">Recusar Proposta</vs-button>
    <vs-button class="bg-primary mt-4 ml-2" @click="validate" v-if="isCreateOrAssigned">Salvar</vs-button>

    <vs-popup :active.sync="popupActivo" title="Aviso">Selecione um garantidor antes de escolher as notas.</vs-popup>

  </div>


</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import CompanyForm from '../../components/CompanyForm'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import NumericInput from '../../components/NumericInput'
import SerasaForm from '../../components/SerasaForm'
import UploadPropostaFile from "../UploadPropostaFile"
import ComplianceForm from "@/components/ComplianceForm";
import CnpjInput from "@/components/CnpjInput";

export default {
  name: 'PropostaAdd',
  components: {
    ComplianceForm,
    CnpjInput,
    SerasaForm,
    NumericInput,
    DatePicker,
    moment,
    CompanyForm,
    UploadPropostaFile
  },
  props: {
    proposeDb: Object,
    proposeConfigDb: Array
  },
  watch: {
    clientIsGuarantor (newVal) {
      this.setClientIsGuarantor(newVal)
    },
    proposeDb (newVal) {
      Object.assign(this.propose, newVal)
      this.getSerasaValues()
      this.getComplianceValues()
    },
    proposeConfigDb (newVal) {
      if (Array.isArray(newVal)) {
        this.proposeConfig = newVal
      }
    }
  },
  data () {
    return {
      proposeTypes: [],
      newPropose: {
        clientCnpj: null,
        clientCnpjAlfa: null,
        guarantorCnpj: null,
        guarantorCnpjAlfa: null,
        operationType: null,
        proposeType: null,
        serasa: null,
        compliance: null,
        requestComplianceReport: null,
        guaranteeType: null,
        guaranteePeriod: null,
        paymentTerm: null,
        comments: null,
        amount: null,
        values: null,
        guid: null,
      },
      complianceServiceType: null,
      clientName: '',
      guarantorName: '',
      names: [],
      propostaFile: '',
      uploadFile: '',
      files: [],
      dataBalanco: null,
      years: [],
      cnpjClient: '',
      cnpjGarantor: '',
      notFoundClient: null,
      notFoundGarantor: null,
      clientIsGuarantor: false,
      promptActivo: false,
      complianceActivo: false,
      popupActivo: false,
      propose: {
        codigo: null,
        proposeType: null,
        createdAt: null,
        operationType: null,
        guid: null,
        config: {
          approved: null,
          client: { guid: null },
          guarantor: { guid: null },
          balanceDtoTable: null,
          balances: null,
          guaranteeType: null,
          guaranteePeriod: null,
          values: [],
          serasa: null,
          compliance: null,
          balance: null,
        },
        groupedValues: null,
        approved: null,
        assignable: null,
        approvedDescription: null,
        proposeSla: {},
        createdBy: null,
        status: null,
        lastSla: {},
        slaMessage: {},
        action: null,
        files: [],
        balances: [],
      },
      proposeConfig: [],
      guaranteeTypes: [],
      types: [
        {
          description: 'Negociando uma Compra',
          value: 'LONG'
        },
        {
          description: 'Negociando uma Venda',
          value: 'SHORT'
        },
        {
          description: 'Negociando um Swap',
          value: 'SWAP'
        }
      ],
      serasaValues: [],
      serasa: null,
      newSerasaValue: null,
      serasaNullValue: false,
      creditRating2Serasa: false,
      complianceValues: [],
      compliance: null,
      slaAction: {
        action : null,
        comments: null,
      }
    }
  },
  beforeMount () {
    this.loadNewPropose()
    this.complianceService()
    this.loadProposeTypes()
    this.checkProposeType()
  },
  computed: {

    isCurrentUserAssigned() {
      if (this.proposeDb.lastSla && this.proposeDb.lastSla.userAssigned) {
        const user = JSON.parse(localStorage.currentUser);
        if (this.proposeDb.lastSla.userAssigned.email == user.email)
          return true
      }
      return false
    },

    isCreateOrAssigned() {
      return (this.isCurrentUserAssigned || this.propose.guid === null || this.propose.guid === '')
    }

  },
  methods: {

    checkProposeType() {
      let currentUser = JSON.parse(localStorage.currentUser);
      if (currentUser.tenant === 'ALSOL') {
        this.propose.proposeType = 'UNDEFINED_TIME'
      } else {
        this.propose.proposeType = 'ENERGY'
      }
    },

    loadProposeTypes() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/propose-config/types`)
        .then((response) => {
          this.proposeTypes = response.data
        })
    },

    complianceService() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant/role`, {
        params: {
          role: 'COMPLIANCE'
        }
      })
        .then((response) => {
          this.complianceServiceType = response.data.type
        })
    },

    back () {
      this.$router.push({ path: '/propose' })
    },

    handleFileUpload () {
      for (let i = 0; i < this.$refs.file.files.length; i++) {
        this.files.push(this.$refs.file.files[i])
      }
    },

    updateValues () {
      this.propose.config.values = this.$refs.uploadProposta.valueResponse
    },

    validate () {
      this.serasa = this.$refs.serasaForm.getSelected()
      this.compliance = this.$refs.complianceForm.getSelected()
      this.newPropose.requestComplianceReport = this.$refs.complianceForm.getRequestReport()

      if (this.propose.proposeType !== 'UNDEFINED_TIME') {
        if (this.propose.config.values == null || this.propose.config.values.length === 0) {
          this.$vs.notify({
            color: 'danger',
            text: 'Não há prazo de fornecimento na proposta.'
          })
          return
        }
      }

      if (this.serasa == null || (this.compliance == null && this.newPropose.requestComplianceReport !== true)) {
        this.$vs.notify({
          color: 'danger',
          text: 'Selecione as notas Serasa e Compliance.'
        })
        return
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.propose.guid == null || this.propose.guid === '') {
            this.createPropose()
          } else {
            this.updatePropose()
          }
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },

    loadNewPropose () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/guarantee-types`)
        .then((response) => {
          this.guaranteeTypes = response.data
        })
    },

    setClientIsGuarantor (toggle) {
      if (toggle) {
        this.propose.config.guarantor = this.propose.config.client
        this.isMatriz(this.propose.config.guarantor)
        this.getSerasaValues()
        this.getComplianceValues()
      } else {
        this.propose.config.guarantor = { }
      }
    },

    getCompany (isClient) {
      let cnpj = ''

      if (isClient) {
        cnpj = this.cnpjClient
      } else {
        if (this.clientIsGuarantor) return
        cnpj = this.cnpjGarantor
      }

      if (cnpj === '') return

      axios.get(`${process.env.VUE_APP_API  }/api/v1/company/cnpj`,
        {
          params: {
            cnpj: cnpj
          }
        })
        .then((response) => {
          if (response.data) {
            if (isClient) {
              this.propose.config.client = response.data
              this.notFoundClient = null
              if (this.clientIsGuarantor) {
                this.propose.config.guarantor = this.propose.config.client
                this.isMatriz(this.propose.config.guarantor)
                this.notFoundGarantor = null
                this.getSerasaValues()
                this.getComplianceValues()
              }
            } else {
              this.propose.config.guarantor = response.data
              this.isMatriz(this.propose.config.guarantor)
              this.notFoundGarantor = null
              this.getSerasaValues()
              this.getComplianceValues()
            }
          }
        })
      .catch((error) => {
        if (isClient) {
          this.notFoundClient = 'Cliente não encontrado'
        } else {
          console.log(error)
          this.notFoundGarantor = 'Garantidor não encontrado'
        }
      })
    },

    isMatriz(guarantor) {
      let guid = guarantor.guid
      let flag = guarantor.matriz

      if (guid == null || guid === '') return

      if (flag == null || flag === false) {
        let msgGarantidor = 'O CNPJ do garantidor é de uma FILIAL.' +
          ' A buscas do serviços integrados como SERASA etc. podem não responder adequadamente' +
          ' Caso deseje continuar, as informações financeiras DEVEM ser da FILIAL (BP, DRE e FC).'

        this.$vs.dialog({
          buttonsHidden: true,
          color: 'danger',
          title: `Atenção`,
          text: msgGarantidor,
          acceptText: 'Ok',
        })
      }
    },

    createPropose () {
      this.convertNewPropose()

      axios.post(`${process.env.VUE_APP_API}/api/v1/propose`, this.newPropose)
        .then((response) => {
          if (response.status === 201) {
            this.propose.guid = response.data;
            this.submitFile()
          }
        })

    },

    updatePropose () {
      this.convertNewPropose()

      axios.put(`${process.env.VUE_APP_API}/api/v1/propose/${this.propose.guid}`, this.newPropose)
        .then((response) => {
          if (response.status === 200) {
            this.propose.guid = response.data;
            this.nextStep('APPROVE');
          }
        })
    },

    nextStep(slaAction) {
      this.slaAction.action = slaAction
      this.slaAction.comments = this.propose.config.comments
      axios.put(`${process.env.VUE_APP_API}/api/v1/propose/${this.propose.guid}/step`, this.slaAction)
        .then((response) => {
          if (response.status === 201) {
            this.submitFile();
          }
        })

    },

    denyPropose() {
      this.slaAction.action = 'DENIED'

      axios.put(`${process.env.VUE_APP_API}/api/v1/propose/${this.propose.guid}/step`, this.slaAction)
        .then((response) => {
          this.propose.guid = response.data
          this.$router.push({path: '/propose'})
        })
        .catch(() => { })
    },

    submitFile() {
      if (this.files == null || this.files.length === 0) {
        this.back()
        return
      }

      let formData = new FormData()

      for (let i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i]);
      }

      formData.append('proposeGuid', new Blob([
        JSON.stringify(
          this.propose.guid
        )
      ]))

      axios.post(`${process.env.VUE_APP_API}/api/v1/file/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).finally(() => {
        this.$router.push({path: '/propose'})
      })
    },

    getSerasaValues () {
      if (this.propose.config.guarantor.guid) {
        axios.get(process.env.VUE_APP_API + '/api/v1/serasa/' + this.propose.config.guarantor.guid)
        .then((response) => {
          this.serasaValues = response.data
        })
      }
    },

    getComplianceValues () {
      if (this.propose.config.guarantor.guid) {
        axios.get(process.env.VUE_APP_API + '/api/v1/compliance/' + this.propose.config.guarantor.guid)
          .then((response) => {
            this.complianceValues = response.data
          })
      }
    },

    downloadTemplate () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/propose/template`,
        {
          responseType: 'blob'
        }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = response.headers["x-suggested-filename"]
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
    },

    downloadFile(row) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/file/download`,{
        params: {
          proposeGuid: this.propose.guid,
          fileName: row,
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

    eraseValues() {
      this.propose.config.values = []
    },

    convertNewPropose() {
      this.propose.lastSla.action = 'APPROVE'
      this.propose.config.operationType = 'LONG'
      this.propose.config.serasa = this.serasa
      this.propose.config.scoreCompliance = this.compliance

      let count = 0
      for (let idx = 0; idx < this.propose.config.values.length; idx++) {
        if (this.propose.config.operationType !== this.propose.config.values[idx].operationType) {
          this.propose.config.operationType = this.propose.config.values[idx].operationType
          count++
        }
      }

      if (count > 1) this.propose.operationType = 'SWAP'

      this.newPropose.proposeType = this.propose.proposeType
      this.newPropose.clientCnpj = this.propose.config.client.cnpj
      this.newPropose.clientCnpjAlfa = this.propose.config.client.cnpjAlfa || this.propose.config.client.cnpj
      this.newPropose.guarantorCnpj = this.propose.config.guarantor.cnpj
      this.newPropose.guarantorCnpjAlfa = this.propose.config.guarantor.cnpjAlfa || this.propose.config.guarantor.cnpj
      this.newPropose.operationType = this.propose.config.operationType
      this.newPropose.serasa = this.serasa
      this.newPropose.compliance = this.compliance
      this.newPropose.guaranteeType = this.propose.config.guaranteeType
      this.newPropose.guaranteePeriod = this.propose.config.guaranteePeriod
      this.newPropose.paymentTerm = this.propose.config.paymentTerm
      this.newPropose.comments = this.propose.config.comments
      this.newPropose.amount = this.propose.config.totalAmount
      this.newPropose.values = this.propose.config.values

      if (this.propose.guid != null ) {
        this.newPropose.guid = this.propose.guid
      }
    }

  }

}
</script>

<style scoped>
  /* Don't forget to hide the original file input! */
  .file-select > input[type="file"] {
    display: none;
  }
  .cardx {
    margin: 0px
  }
</style>
